<template>
  <section class="strategy-loop">
    <div class="loop-title">预测与策略闭环</div>
    <div class="loop-steps">
      <template v-for="(item, index) in steps" :key="item">
        <span>{{ item }}</span>
        <i v-if="index < steps.length - 1"></i>
      </template>
    </div>
    <p>模型捕捉到采收期和转运变化，预测精度随样本积累提升</p>
  </section>
</template>

<script setup>
const steps = ["数据输入", "模型拟合", "产量预估", "风险评估", "销售规划", "存储规划"];
</script>

<style lang="less" scoped>
.strategy-loop {
  position: relative;
  height: 230px;
  flex-shrink: 0;
  border: 1px solid rgba(45, 255, 232, 0.72);
  background:
    linear-gradient(180deg, rgba(0, 93, 84, 0.46), rgba(0, 43, 43, 0.74)),
    rgba(0, 56, 50, 0.45);
  box-shadow: inset 0 0 36px rgba(35, 255, 229, 0.12);
  clip-path: polygon(0 28px, 28px 0, 100% 0, 100% 100%, 0 100%);
}

.loop-title {
  position: absolute;
  top: -2px;
  left: 50%;
  min-width: 360px;
  height: 62px;
  padding: 0 60px;
  color: #ffffff;
  font-size: 34px;
  font-weight: 700;
  line-height: 62px;
  text-align: center;
  transform: translateX(-50%);
  background: linear-gradient(90deg, transparent, rgba(0, 118, 108, 0.94), transparent);
}

.loop-steps {
  height: 150px;
  padding: 74px 80px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 34px;
  box-sizing: border-box;
}

.loop-steps span {
  width: 178px;
  height: 64px;
  border: 1px solid rgba(72, 255, 238, 0.8);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 28px;
  font-weight: 700;
  background: rgba(0, 86, 78, 0.66);
  box-shadow: inset 0 0 16px rgba(45, 255, 232, 0.1);
}

.loop-steps i {
  width: 46px;
  height: 4px;
  position: relative;
  background: #e7fffc;
}

.loop-steps i::after {
  content: "";
  position: absolute;
  top: -8px;
  right: -2px;
  width: 18px;
  height: 18px;
  border-top: 4px solid #e7fffc;
  border-right: 4px solid #e7fffc;
  transform: rotate(45deg);
}

p {
  margin: 0;
  color: #d9fffb;
  font-size: 30px;
  font-weight: 700;
  margin-top: 30px;
}
</style>
